import type { ReactNode } from 'react';
import './EmptyState.css';

export interface EmptyStateProps {
  /** Required — content.md: "empty states always pair an explainer with a
   * primary CTA. Never a bare 'No data' message." A title alone would fail
   * that rule, so it is required, not optional. */
  title: string;
  description: string;
  icon?: ReactNode;
  /** The primary CTA. Optional only for the rare screen where there is
   * genuinely no next action (e.g. a fully-resolved queue) — prefer
   * providing one. */
  action?: ReactNode;
}

export function EmptyState({ title, description, icon, action }: EmptyStateProps) {
  return (
    <div className="dpr-empty-state">
      {icon ? (
        <span className="dpr-empty-state__icon" aria-hidden="true">
          {icon}
        </span>
      ) : null}
      <p className="dpr-empty-state__title">{title}</p>
      <p className="dpr-empty-state__description">{description}</p>
      {action ? <div className="dpr-empty-state__action">{action}</div> : null}
    </div>
  );
}
